/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class HoldingPdfService {

    /**
     * @param participantId
     * @returns any OK
     * @throws ApiError
     */
    public static getApiAwardApiHoldingPdf(
        participantId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/holding/{participantId}/pdf',
            path: {
                'participantId': participantId,
            },
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public static getApiAwardApiHoldingMyHoldingPdf(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/holding/my-holding/pdf',
        });
    }

}
